import { genericFields, partRelationData, pubtypeGroupData } from '../Settings/pubtype-mappings';
import { FieldSettings, Pubtype, PubtypeGroup, WorkField } from './types';

export abstract class PubtypeUtils {
  /**
   * Returns a list of all fields of the group.
   *
   * @param group
   */
  static getFieldsByPubtypeGroup = (group: PubtypeGroup): WorkField[] => {
    if (!group || !pubtypeGroupData.hasOwnProperty(group)) {
      return [];
    }
    return [...genericFields, ...pubtypeGroupData[group].fields];
  };

  /**
   * Returns a list of all fields of the pubtype.
   *
   * @param pubtype
   */
  static getFieldsByPubtype = (pubtype: Pubtype): WorkField[] => {
    if (!pubtype) {
      return [];
    }
    const group: PubtypeGroup = PubtypeUtils.getGroupByPubtype(pubtype);
    if (!group) {
      return [];
    }
    return PubtypeUtils.getFieldsByPubtypeGroup(group);
  };

  /**
   * Returns all pubtypes belonging to the group.
   *
   * @param group
   */
  static getPubtypesByGroup = (group: PubtypeGroup): Pubtype[] => {
    if (!pubtypeGroupData.hasOwnProperty(group)) {
      return [];
    }
    return pubtypeGroupData[group].pubtypes;
  };

  /**
   * Returns the group which the pubtype belongs to.
   *
   * @param pubtype
   */
  static getGroupByPubtype = (pubtype: Pubtype): PubtypeGroup => {
    return Object.keys(pubtypeGroupData)
      .find((key: string): boolean => pubtypeGroupData[key].pubtypes.includes(pubtype));
  };

  /**
   * Returns the list of fields included in group1 and group 2.
   *
   * @param group1
   * @param group2
   */
  static getIntersection = (group1: PubtypeGroup, group2: PubtypeGroup): WorkField[] => {
    const fields1: WorkField[] = PubtypeUtils.getFieldsByPubtypeGroup(group1);
    const fields2: WorkField[] = PubtypeUtils.getFieldsByPubtypeGroup(group2);
    return fields1.filter((field: WorkField): boolean => fields2.includes(field));
  };

  /**
   * Return the list of fields, included in group1 but not in group2.
   *
   * @param group1
   * @param group2
   */
  static getRemovedFields = (group1: PubtypeGroup, group2: PubtypeGroup): WorkField[] => {
    const fields1: WorkField[] = PubtypeUtils.getFieldsByPubtypeGroup(group1);
    const fields2: WorkField[] = PubtypeUtils.getFieldsByPubtypeGroup(group2);
    return fields1.filter((field: WorkField): boolean => !fields2.includes(field));
  };

  /**
   * Return the list whether fields are displayed or not for the isPartOf-Relation of pubtype1 and pubtype2.
   *
   * @param pubtype1
   * @param pubtype2
   */
  static getIsPartOfFields = (pubtype1: PubtypeGroup, pubtype2: PubtypeGroup): FieldSettings => {
    if (!pubtype1 || !pubtype2 || !partRelationData.hasOwnProperty(pubtype1) || !partRelationData[pubtype1] || !partRelationData[pubtype1].hasOwnProperty(pubtype2)) {
      return {
        issue: false,
        articleId: false,
        pageFirst: false,
        pageLast: false,
        volume: false,
      };
    }
    return partRelationData[pubtype1][pubtype2];
  };
}
